import { ComponentLikeType, DistributorDataTypeV2 } from 'elements/hardwareSelectorV2/types'
import { useTranslate } from 'ra-core'
import { useMemo } from 'react'

export const BULK_PRICE_MESSAGE = 'Bulk price available'

const useBulkOptions = ({
  component,
  selectedDistributor,
}: {
  component: ComponentLikeType | undefined
  selectedDistributor: DistributorDataTypeV2 | undefined
}) => {
  const translate = useTranslate()

  const { isBulkAvailable, lowestBulkPrice, bulkPriceDistributorNames } = useMemo(() => {
    let isBulkAvailable = false
    let lowestBulkPrice = Infinity
    const bulkPriceDistributorNames: string[] = []
    if (!component) return { isBulkAvailable, lowestBulkPrice: 0, bulkPriceDistributorNames }

    component.ordering_v2.forEach((dist) => {
      if (dist.bulk_options.length) {
        bulkPriceDistributorNames.push(dist.distributor_name)
        isBulkAvailable = true
        lowestBulkPrice = Math.min(lowestBulkPrice, ...dist.bulk_options.map((bulkOption) => bulkOption.price_per_unit))
      }
    })
    if (lowestBulkPrice === Infinity) {
      lowestBulkPrice = 0
    }
    return { isBulkAvailable, lowestBulkPrice, bulkPriceDistributorNames }
  }, [component])

  const selectedDistributorLowestBulkPrice = useMemo(() => {
    if (!selectedDistributor?.bulk_options?.length) return undefined
    return Math.min(...selectedDistributor.bulk_options.map((bulkOption) => bulkOption.price_per_unit))
  }, [selectedDistributor])

  const bulkOptions = useMemo(() => {
    if (!selectedDistributor?.bulk_options?.length) return []
    return [...selectedDistributor.bulk_options].sort((a, b) => a.quantity_per_item - b.quantity_per_item)
  }, [selectedDistributor])

  return {
    isBulkAvailable,
    lowestBulkPrice,
    bulkPriceDistributorNames,
    selectedDistributorLowestBulkPrice,
    bulkOptions,
    bulkPriceMessage: translate(BULK_PRICE_MESSAGE),
  }
}

export default useBulkOptions
